import { LOAD_STATUSES } from '@cargoflow/validators'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { Loads } from '@/features/loads'

const ZodLoadsSearch = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  status: z.array(z.enum(LOAD_STATUSES)).optional().catch([]),
  origin: z.string().optional().catch(undefined),
  origin_country: z.array(z.string()).optional().catch([]),
  origin_county: z.array(z.string()).optional().catch([]),
  sort_by: z
    .enum(['created_at', 'loading_date_from', 'price_min', 'status'])
    .optional()
    .catch(undefined),
  sort_dir: z.enum(['asc', 'desc']).optional().catch(undefined),
  show_all: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/loads/')({
  validateSearch: ZodLoadsSearch,
  component: Loads,
})
